import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-r",
  "use": "arrow-r-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-r\"><defs><style>#arrow-r .cls-1{fill:none}</style></defs><title>资源 64</title><g id=\"arrow-r_图层_2\" data-name=\"图层 2\"><g id=\"arrow-r_图层_1-2\" data-name=\"图层 1\"><path id=\"arrow-r_Rectangle_36_Copy_5\" data-name=\"Rectangle 36 Copy 5\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"arrow-r_right\"><path id=\"arrow-r_Shape\" d=\"M7.05 21a1.05 1.05 0 0 0 .64-.22l9.93-8a1 1 0 0 0 .16-1.44l-.16-.16-9.89-7.95a1 1 0 1 0-1.28 1.6l8.9 7.17-8.95 7.17A1 1 0 0 0 7.05 21z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-r.svg
// module id = toOo
// module chunks = 6